// src/pages/Contact.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { 
  MapPin, 
  Phone, 
  Smartphone, 
  MessageCircle, 
  Clock, 
  ChevronRight
} from '../components/icons';

const branches = [
  {
    id: 1,
    name: "شعبه مرکزی - چهارباغ عباسی",
    address: "اصفهان، چهارباغ عباسی، بازار هنر، پلاک ۶",
    phone: "03132222042",
    mobile: "09215316012",
    whatsapp: "09215316012",
    hours: "شنبه تا پنجشنبه : ۱۰ صبح الی ۱۳ و ۱۷ الی ۲۱",
    // لینک دقیق از گوگل مپ
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d836.123456789!2d51.6687227!3d32.6523385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fbc35e5ca1badbb%3A0xfc66f80a76c78171!2sKhorrami+Jewelry+Store!5e0!3m2!1sen!2s!4v1234567890!5m2!1sen!2s"
  },
  {
    id: 2,
    name: "شعبه نقش جهان - بازار تفنگسازها",
    address: "اصفهان، میدان نقش جهان، بازار تفنگسازها، فروشگاه خرمی",
    phone: "03132235425",
    mobile: null,
    whatsapp: null,
    hours: "شنبه تا پنجشنبه:۱۱ الی ۱۸",
    // مختصات دقیق + زوم مناسب
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d836.123456789!2d51.6778858!3d32.6610865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzLCsDM5JzM5LjkiTiA1McKwNDAnNDAuNCJF!5e0!3m2!1sen!2s!4v1234567890!5m2!1sen!2s"
  }
];

export default function Contact() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white py-16 px-6">
      {/* هدر */}
      <div className="max-w-7xl mx-auto text-center mb-16">
        <motion.h1 data-page-title="true"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-4xl md:text-5xl font-bold text-gray-800 mb-4"
        >
          تماس با ما
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-lg text-gray-600 max-w-2xl mx-auto"
        >
          شعب ما در قلب اصفهان — چهارباغ عباسی و میدان نقش جهان
        </motion.p>
      </div>

      {/* شعب */}
      <div className="max-w-7xl mx-auto space-y-12">
        {branches.map((branch, index) => (
          <motion.div
            key={branch.id}
            initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.2 }}
            className="bg-white rounded-3xl shadow-xl overflow-hidden"
          >
            <div className="grid md:grid-cols-2">
              {/* اطلاعات شعبه */}
              <div className="p-8 md:p-10 space-y-6">
                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-2">
                    {branch.name}
                  </h2>
                  <p className="text-gray-600 flex items-start gap-2">
                    <MapPin className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
                    <span className="leading-relaxed">{branch.address}</span>
                  </p>
                </div>

                <div className="space-y-3">
                  <a
                    href={`tel:${branch.phone.replace(/[^0-9]/g, '')}`}
                    className="flex items-center gap-3 text-gray-700 hover:text-amber-600 transition-colors"
                  >
                    <Phone className="w-5 h-5 text-amber-600" />
                    <span className="font-medium">{branch.phone}</span>
                  </a>

                  {branch.mobile && (
                    <a
                      href={`tel:${branch.mobile.replace(/[^0-9]/g, '')}`}
                      className="flex items-center gap-3 text-gray-700 hover:text-green-600 transition-colors"
                    >
                      <Smartphone className="w-5 h-5 text-green-600" />
                      <span className="font-medium">{branch.mobile}</span>
                    </a>
                  )}

                  {branch.whatsapp && (
                    <a
                      href={`https://wa.me/${branch.whatsapp.replace(/[^0-9]/g, '')}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 text-gray-700 hover:text-green-600 transition-colors"
                    >
                      <MessageCircle className="w-5 h-5 text-green-600" />
                      <span className="font-medium">واتساپ: {branch.whatsapp}</span>
                    </a>
                  )}
                </div>

                <div className="pt-4 border-t border-gray-100">
                  <p className="text-sm text-gray-600 flex items-start gap-2">
                    <Clock className="w-4 h-4 text-amber-600 mt-0.5" />
                    <span className="leading-relaxed whitespace-pre-line">
                      {branch.hours}
                    </span>
                  </p>
                </div>

                <a
                  href={branch.mapUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-amber-600 text-white px-5 py-3 rounded-xl font-semibold hover:bg-amber-700 transition-colors"
                >
                  نمایش در گوگل مپ
                  <ChevronRight className="w-4 h-4" />
                </a>
              </div>

              {/* نقشه — بدون grayscale */}
              <div className="h-64 md:h-auto">
                <iframe
                  title={`نقشه ${branch.name}`}
                  src={branch.mapUrl}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="transition-all duration-300 hover:shadow-inner"
                />
              </div>
            </div>
          </motion.div>
        ))}
      </div>

    

      {/* دکمه شناور واتساپ */}

<motion.a
  href="https://wa.me/989215316012"
  target="_blank"
  rel="noopener noreferrer"
  initial={{ scale: 0 }}
  animate={{ scale: 1 }}
  whileHover={{ scale: 1.1 }}
  whileTap={{ scale: 0.9 }}
  className="
    fixed 
    bottom-20 
    left-4 
    bg-green-500 
    text-white 
    p-4 
    rounded-full 
    shadow-2xl 
    z-50 
    flex 
    items-center 
    justify-center
    md:hidden
  "
  style={{
    paddingBottom: 'calc(1rem + env(safe-area-inset-bottom))'
  }}
  title="چت در واتساپ"
>
  <MessageCircle className="w-6 h-6" />
</motion.a>
    </div>
  );
}